import { Component, OnInit } from '@angular/core';
import {IbRequest} from '../ib-request';
import {IbResponse} from '../ib-response';
import {Angular2CsvModule} from 'angular2-csv';
import {MyDatePickerModule, IMyDpOptions,IMyDateModel} from 'mydatepicker';
import { CallBackEndService } from '../call-back-end.service';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import 'rxjs/Rx';
import {DatePipe} from "@angular/common";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
@Component({
  selector: 'app-cheque-status-request',
  templateUrl: './cheque-status-request.component.html',
  styleUrls: ['./cheque-status-request.component.css'],
  providers: [DatePipe]
})
export class ChequeStatusRequestComponent implements OnInit {
  data: any [];
  public filterQuery = '';
  public rowsOnPage = 5;
  public sortBy = 'particulars';
  public sortOrder = 'asc';
  accountNo : string ='';
  option : string ='';
  chequeNo : string ='';
  fromDate : any ;
  toDate : any ;
  message : string ='';
  isShow : string =' ';
  chequeNORequired : string ='';
  disabled : boolean=false;
  isShow1 : string =' ';
  chequeStatusResp :any ;
  chequeStatusList1 : any ;
  chequeStatusList : any ;
  chequeNoNoSpace : string='';
  chequeNoNumber : string ='';
  chequeNospecial : string ='';
  chequeNoZeroOnly : string ='';
  chequeNoSpace : string ='';
  chequebNumber : string ='';
  chequespecial : string ='';
  disableSubBtn:boolean=false;
  acctNoBlank : string ='';
  isError:boolean=false;
  error:string="";
  OptRequired:string="";
  scoAccounts : any;
  fromDateRequired : string='';
  toDateRequired : string='';
  ditgreatnot : string ='';
  fromDateNull : string ='';
  toDateNull : string='';
  messageForDate : string = '';
  messageForDate1 : string = '';
  messageForDate2 : string = '';
  fromGreaterCurrent : string ='';
  mytime:Date = new Date();
  currentYear:any= this.mytime.getUTCFullYear();
  currentDate:any= this.mytime.getUTCDate()+1;
  currentMonth:any= this.mytime.getUTCMonth() + 1;
  currentMonth1:any= this.mytime.getUTCMonth() + 7;
  fromyear=this.mytime.getUTCFullYear()-2;
  formatedDate : string='';
  constructor(private webService: CallBackEndService,private datePipe: DatePipe,private spinnerService: Ng4LoadingSpinnerService) {

    this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
  }

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
    disableUntil:{year: this.fromyear, month: this.currentMonth, day: this.currentDate-2},
  };
  myDatePickerOptions1: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
    disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate},
  };
  chequeStatusRequest(){
    this.isError=false;
    if(this.accountNo===undefined || this.accountNo===''|| this.accountNo===' ')
    {
      this.acctNoBlank='no';
      console.log("aaa1");

    }else if(this.option===undefined || this.option===''|| this.option===' ')
    {
      this.OptRequired='no';
      console.log("aaa11");

    }else {

      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isFromDateLessThanOrEqualToDate1();
      var reg=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
      var regNum = /^[0-9]+$/;
      var regchar='/^[a-zA-Z]+$/';
      var regexpspace=/\s+/;
      var regZeroOnly='^[0][0]*[0]$';
      if(this.accountNo && this.option==='1'){


        if(this.chequeNo==="" || this.chequeNo===undefined)
        {
          this.chequeNORequired='no';


        }else if(this.chequeNo===" " || this.chequeNo.indexOf(' ') !== -1)
        {
          this.chequeNoNoSpace='no';


        }
        else if(!this.chequeNo.match(regNum))
        {
          this.chequeNoNumber='no';

        }
        else if(this.chequeNo.match(reg))
        {
          this.chequeNospecial='no';

        }
        else if(this.chequeNo.match(regZeroOnly))
        {
          this.chequeNoZeroOnly='no';

        }
        else if(this.chequeNo.length>12)
        {
          this.ditgreatnot='no';

        }
        else{
          this.disableSubBtn=true;
            this.spinnerService.show();
          //this.isShow1='hide1';
          this.isShow='hide';
          //console.log(getHexAscii("",this.accountNo+this.option+this.chequeNo));

          request.param1 = getHexAscii("",this.accountNo+this.option+this.chequeNo+sessionStorage.getItem('storedUserName')),
            request.param2 = this.accountNo,
            request.param3 = this.option,
            request.param4 = this.chequeNo;
            request.param5 =sessionStorage.getItem('storedUserName');
          this.webService.getResponse(request, 'chequeStatus').subscribe((data: IbResponse) => {
              this.spinnerService.hide();
            this.chequeStatusResp=data;
          //  this.spinnerService.hide();
            if (this.chequeStatusResp.status === 'S101'){
              alert('Malicious Request Detected');
            }
            if(this.chequeStatusResp.status==='S200'){
              this.data= this.chequeStatusResp.param6;
              // if(this.data)
              this.isShow='show1';

            }else{
              this.isShow='';
              this.disableSubBtn=false;
              this.isError=true;
              this.error=this.chequeStatusResp.statusDescription;
              this.message=this.chequeStatusResp.statusDescription;
            }
          });
        }}

      if((this.accountNo&& this.option==='2') ){
        this.messageForDate = '';
        this.messageForDate1 = '';
        this.messageForDate2 = '';
        this.fromGreaterCurrent = '';
        console.log("date---"+this.fromDate+"@@@"+this.toDate)
        if(this.fromDate==="" || this.fromDate===undefined)
        {
          this.fromDateRequired='no';
          console.log("aaa2");

        }else  if(this.toDate==="" || this.toDate===undefined)
        {
          this.toDateRequired='no';
          console.log("aaa2");

        }
        else {
          var date1 = (this.fromDate.date.day + "-" + this.dateconvert(this.fromDate.date.month) + "-" + this.fromDate.date.year).split("-");
          var date2 = (this.toDate.date.day + "-" + this.dateconvert(this.toDate.date.month) + "-" + this.toDate.date.year).split("-");
          var date3 = this.formatedDate.split("-");
          console.log('dates in cheque status : '+date1+date2+date3);
          var d1 = Date.parse(date1[0] + "-" + date1[1] + "-" + date1[2]);
          var d2 = Date.parse(date2[0] + "-" + date2[1] + "-" + date2[2]);
          var d3 = Date.parse(date3[0] + "-" + date3[1] + "-" + date3[2]);
          if (d1 > d2) {
            this.messageForDate = 'no';
            //  this.subBtnDisabled = false;
            this.spinnerService.hide();
          } else if (d2 > d3) {
            this.messageForDate1 = 'no';
            // this.subBtnDisabled = false;
            this.spinnerService.hide();
          } else if (d1 > d3) {
            this.fromGreaterCurrent = 'no';
            //  this.subBtnDisabled = false;
            this.spinnerService.hide();
          } else {
            this.isShow = 'hide';
            this.disableSubBtn = true;
             this.spinnerService.show();
            //  const frm =JSON.stringify(this.fromDate);
            console.log("frm date " + this.fromDate.formatted + "");
            console.log("frm year " + this.fromDate.date.year + "");
            console.log("frm month " + this.fromDate.date.month + "");
            console.log("frm day " + this.fromDate.date.day + "");
            request.param2 = this.accountNo;
            request.param3 = this.option;
            request.param4 = this.fromDate.date.day + "-" + this.getMonthName(this.fromDate.date.month) + "-" + this.fromDate.date.year;
            request.param5 = this.toDate.date.day + "-" + this.getMonthName(this.toDate.date.month) + "-" + this.toDate.date.year;
             request.param6 = {
        'userName':sessionStorage.getItem('storedUserName'),
      };
            request.param1 = getHexAscii("", this.accountNo + this.option + request.param4 + request.param5+sessionStorage.getItem('storedUserName'));
            
            console.log("comeeee");
            console.log("from date  " + request.param4 + "to date  " + request.param5);
            this.spinnerService.hide();
            this.webService.getResponse(request, 'chequeStatus').subscribe((data: IbResponse) => {
               this.spinnerService.hide();
              this.chequeStatusResp = data;
              if (this.chequeStatusResp.status === 'S101') {
                alert('Malicious Request Detected');
              }
              if (this.chequeStatusResp.status === 'S200') {
                this.data = this.chequeStatusResp.param6;

                this.isShow = 'show';
                this.disableSubBtn = false;

              } else {
                this.isShow = '';
                this.isError = true;
                this.error = this.chequeStatusResp.statusDescription;
                this.disableSubBtn = false;
                this.message = this.chequeStatusResp.statusDescription;
              }
            });
          }
        }
      }
    }
  }
  isFromDateLessThanOrEqualToDate()
  {

  }
  isFromDateLessThanOrEqualToDate1()
  {

  }

  getMonthName(month)
  {
    return ["Jan","Feb","Mar","Apr","May","June","Jul","Aug","Sep", "Oct","Nov","Dec"][Number(month)-1];
  }
  close()
  {

  }

  ngOnInit() {
    this.formatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
  //  console.log("date : "+this.formatedDate);
  }
  removeAccMsgs(){
    this.acctNoBlank="";
  }
  removeOtpMsgs()
  {
    this.OptRequired="";
  }
  removeChequeMsgs()
  {
    this.chequeNORequired='';
    this.chequeNoNoSpace='';
    this.chequeNoNumber ='';
    this.chequeNospecial ='';
    this.chequeNoZeroOnly='';
    this.chequeNoSpace='';
    this.chequebNumber='';
    this.chequespecial='';
    this.ditgreatnot='';
  }
  optChange()
  {
    this.error="";
    this.isError=false;
    this.isShow='';
    this.chequeNo='';
    this.fromDate='';
    this.toDate='';
  }
  removeFromdateMsgs(event: IMyDateModel)
  {
   
    let date1=JSON.stringify(event.formatted);
    if(event==null){
       this.fromDateRequired = 'no';
    }
     else if (date1==='""'||date1==='" "'||date1==='"  "' ||date1===undefined||date1===null) 
    {
     this.fromDateRequired = 'no';
     
     }else{
    
    this.fromDateRequired='';
   }
  }
  removeToDateMsgs(event: IMyDateModel)
  {
    //console.log("date1.length----"+date1.length+"date2"+date2+"date1"+date1+"@@@@"+date3);
     let date1=JSON.stringify(event.formatted);
    if(event==null){
       this.toDateRequired = 'no';
    }
     else if (date1==='""'||date1==='" "'||date1==='"  "' ||date1===undefined||date1===null) 
    {
     this.toDateRequired = 'no';
     
     }else{
    
    this.toDateRequired='';
   }
  }
  dateconvert(monthNumber) { //1 = January
    var monthNames = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
      'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
    return monthNames[monthNumber - 1];
  }
  validateAccNo()
  {
     if(this.accountNo===undefined || this.accountNo===''|| this.accountNo===' ')
    {
      this.acctNoBlank='no';
     }
  }
  validateOption()
  {
    if(this.option===undefined || this.option===''|| this.option===' ')
    {
      this.OptRequired='no';
      console.log("aaa11");

    }
  }
  validateChequeNo()
  {
     var reg=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
      var regNum = /^[0-9]+$/;
      var regchar='/^[a-zA-Z]+$/';
      var regexpspace=/\s+/;
      var regZeroOnly='^[0][0]*[0]$';
    if(this.chequeNo==="" || this.chequeNo===undefined)
        {
          this.chequeNORequired='no';


        }else if(this.chequeNo===" " || this.chequeNo.indexOf(' ') !== -1)
        {
          this.chequeNoNoSpace='no';


        }
        else if(!this.chequeNo.match(regNum))
        {
          this.chequeNoNumber='no';

        }
        else if(this.chequeNo.match(reg))
        {
          this.chequeNospecial='no';

        }
        else if(this.chequeNo.match(regZeroOnly))
        {
          this.chequeNoZeroOnly='no';

        }
        else if(this.chequeNo.length>12)
        {
          this.ditgreatnot='no';

        }
  }
  validateFromDate()
  {
    if(this.fromDate==="" || this.fromDate===undefined)
        {
          this.fromDateRequired='no';
          console.log("aaa2");

        }
  }
  validateToDate()
  {
     if(this.toDate==="" || this.toDate===undefined)
        {
          this.toDateRequired='no';
          console.log("aaa2");

        }
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/cheque-status-request/cheque-status-request.component.ts